import { render, staticRenderFns } from "./ReferralNotes.vue?vue&type=template&id=b0ac7e5c&"
import script from "./ReferralNotes.vue?vue&type=script&lang=js&"
export * from "./ReferralNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports